"use client";
import React from "react";
import styles from "@/styles/component-style/common.module.css";
import { Link } from "@/i18n/navigation";
import { MainData } from "@/components/common/CommonArray/FileArray";

const MainOuterComponent = ({ heading = "Tools", toolType = "" }) => {
  return (
    <div className={styles.mainOuter} id={`${toolType}-tools`}>
      <div className="container-md">
        <div className={styles.sectionTitle}>
          <span>#{heading}</span>
        </div>
        <div className={styles.grid}>
          {MainData.filter((item) => item.maintype === toolType).map((item) => (
            <Link href={item.navigate} key={item.Name} scroll={false}>
              <div className={styles.gridItems}>
                <div className={styles.subGrid}>
                  <div className={styles.subGridItems}>
                    <div className={styles.iconBox} />
                  </div>
                  <div className={styles.subGridItems}>
                    <span>{item.Name}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainOuterComponent;
